import { Button, Container, Grid, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { freelancerApi } from "../../API/Api";
import FreelancerItem from "./FreelancerItem";
import { motion } from "framer-motion";

const Freelancer = () => {
  const navigate = useNavigate();
  const [freelancerData, setFreelancerData] = useState([]);
  useEffect(() => {
    fetch(freelancerApi)
      .then((res) => res.json())
      .then((result) => {
        setFreelancerData(result.slice(0, 4));
      })
      .catch((error) => console.log("freelancerData Error => ", error));
  }, []);

  return (
    <Box mt={5}>
      {/* Section Header */}
      <Stack
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        spacing={1}
        sx={{ px: 2, mb: -2 }}
      >
        <Typography
          variant="h4"
          component="h2"
          sx={{
            fontWeight: 800,
            fontSize: { xs: "26pt", md: "34pt" },
            background: "linear-gradient(to right, #00C9A7, #0074E4)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: "0.5px",
          }}
        >
          Verified Professionals
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontWeight: 500,
            fontSize: { xs: "13pt", md: "15pt" },
            color: "#9E9E9E",
            maxWidth: "600px",
          }}
        >
          Get connected with verified & experienced professionals
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 500,
            fontSize: { xs: "13pt", md: "15pt" },
            color: "#9E9E9E",
            maxWidth: "600px",
          }}
        >
          for getting your job done with quality.
        </Typography>
      </Stack>

      {/* Freelancer Grid */}
      <Container maxWidth="lg">
        <Grid container spacing={2} mt={4} mb={4}>
          {freelancerData?.map((element) => (
            <Grid item xs={6} sm={6} md={3} key={element.refer_id}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <FreelancerItem freelancerData={element} />
              </motion.div>
            </Grid>
          ))}
        </Grid>

        {/* Load More Button */}
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          mb={4}
        >
          <Button
            variant="contained"
            onClick={() => navigate("/expertlist")}
            sx={{
              px: 5,
              py: 1.5,
              fontSize: "16pt",
              fontWeight: 600,
              textTransform: "none",
              background:
                "linear-gradient(135deg, rgba(0,201,167,0.9), rgba(0,116,228,0.9))",
              borderRadius: "50px",
              boxShadow: "0px 8px 24px rgba(0,201,167,0.3)",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.05)",
                background:
                  "linear-gradient(135deg, rgba(0,201,167,1), rgba(0,116,228,1))",
              },
            }}
          >
            Load more...
          </Button>
          {/* <Button
            variant="outlined"
            sx={{
              fontWeight: 500,
              fontSize: "18pt",
              textTransform: "none",
              px: 4,
              py: 1.5,
              borderRadius: "12px",
              borderColor: "#22AB7D",
              color: "#22AB7D",
              "&:hover": {
                backgroundColor: "#22AB7D10",
                borderColor: "#22AB7D",
              },
            }}
            onClick={() => navigate("/expertlist")}
          >
            Load more...
          </Button> */}
        </Stack>
      </Container>
    </Box>
  );
};

export default Freelancer;
